import { render } from "./NewsSingle.vue?vue&type=template&id=63322937&scoped=true&ts=true"
import script from "./NewsSingle.vue?vue&type=script&lang=ts"
export * from "./NewsSingle.vue?vue&type=script&lang=ts"

import "./NewsSingle.vue?vue&type=style&index=0&id=63322937&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63322937"]])

export default __exports__